<template>
  <div class="code-select">
    <el-select
      class="zwx-select"
      :popper-class="
        popperClass ? 'zwx-select-popper ' + popperClass : 'zwx-select-popper'
      "
      ref="codeSelect"
      v-model="codeValue"
      placeholder="请选择"
      :filterable="true"
      :clearable="clearable"
      :disabled="disabled"
      @change="change"
      :allow-create="allowCreate"
    >
      <el-option
        v-for="item in simpleCodeList"
        :key="item.codeNo"
        :label="item.codeName"
        :value="item.codeNo"
      />
    </el-select>
  </div>
</template>

<script>
export default {
  name: "CodeSelect",
  model: {
    prop: "simpleCodeValue",
    event: "propEvent"
  },
  props: {
    codeType: { type: String },
    simpleCodeValue: { type: String },
    clearable: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    popperClass: { type: String },
    serviceName: { type: String, default: "systematic" },
    apiSign: { type: Boolean, default: true },
    apiWhite: { type: Boolean, default: false },
    allowCreate: { type: Boolean, default: false }
  },
  data() {
    return {
      api: this.$store.state.api,
      simpleCodeList: [],
      codeValue: this.simpleCodeValue
    };
  },
  created() {},
  mounted() {
    this.search();
  },
  watch: {
    simpleCodeValue(newValue) {
      this.codeValue = newValue;
    },
    codeValue(newValue) {
      this.$emit("propEvent", newValue);
    }
  },
  computed: {},
  methods: {
    search() {
      let data = {
        codeTypeCode: this.codeType
      };
      this.$system.get(
        this.api +
          "/" +
          this.serviceName +
          "/getSimpleCodeListByCodeTypeCode-" +
          (this.apiWhite ? "0" : "1"),
        data,
        !this.apiWhite,
        this.apiSign,
        this.searchSuccess,
        this.searchError
      );
    },
    searchSuccess(data) {
      if (data.type === "00") {
        this.simpleCodeList = data.simpleCodeList;
      }
      this.$emit("loadOver");
    },
    searchError() {
      this.$emit("loadOver");
    },
    getSimpleCode() {
      if (
        this.codeValue === undefined ||
        this.codeValue === null ||
        this.codeValue === ""
      )
        return null;
      for (let i = 0, length = this.simpleCodeList.length; i < length; i++) {
        if (this.simpleCodeList[i].codeNo === this.codeValue) {
          return this.simpleCodeList[i];
        }
      }
      return null;
    },
    change(data) {
      this.$emit("change", data);
    }
  }
};
</script>

<style lang="less" scoped>
.code-select {
  display: inline-block;
}
</style>
